import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

// Called from App rather than from a layout: warehouse selection and handheld linking are
// authenticated screens that render outside Layout1, and crashes there are worth attributing
// to an operator too.
export default function useSentryUser(user) {
  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({ id: user.id })
    } else {
      // Warehouse terminals are shared: without this, errors after a logout keep being
      // attributed to whoever was signed in before.
      Sentry.setUser(null)
    }
  }, [user?.id])
}
